import { Types } from '../constants/actionTypes';

const initialState = false

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.UPDATE_OFFERS:
            return {
                ...state,
                offers: action.payload,
            }
        case Types.RESET_OFFERS:
            return {
                ...state,
                offers:false
            }
        case Types.FAVOURITE_OFFER:
            state.offers.results = state.offers.results.map(
                offer=> offer.id === action.payload ?
                    {...offer, isFavourite: true} : offer
            )
            state.offers.refreshFavourites = true
            console.log(state.offers)
            return {
                ...state,
                offers: state.offers
            }
        case Types.UNFAVOURITE_OFFER:
            state.offers.results = state.offers.results.map(
                offer=> offer.id === action.payload ?
                    {...offer, isFavourite: false} : offer
            )
            state.offers.refreshFavourites = true
            return {
                ...state,
                offers: state.offers
            }
        default:
            return {
                ...state,
                offers:initialState
            }
    }
}

export default reducer;